import { OnDatalayerProps } from '@/features/shared/HOCs/withGTM.interface';

enum Selectors {
  Container = '.gtm-headline-container',
  Headline = '.gtm-headline',
  CTA = '.gtm-featured-content-cta',
}

export const onDatalayer = ({ target }: OnDatalayerProps) => {
  const isSeeAll = target?.classList.contains('gtm-see-all');
  const isCTA = target?.classList.contains(Selectors.CTA.replace('.', ''));
  const documentHeadline =
    target?.closest(Selectors.Container)?.querySelector(Selectors.Headline)?.textContent || '';
  const href = target?.href || '';
  const variantName = (target?.closest('[data-datalayer-variant]') as HTMLDivElement)?.dataset
    ?.datalayerVariant;

  if (isCTA) {
    return {
      event: 'clickCTA',
      eventCategory: 'Featured Content',
      documentHeadline,
      href,
      ...(variantName && { variant_name: variantName }),
    };
  }

  if (isSeeAll) {
    return {
      event: 'clickeSeeAll',
      eventCategory: 'Featured Content',
      documentHeadline,
      href,
      ...(variantName && { variant_name: variantName }),
    };
  }

  return undefined;
};
